// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background: #241f1c;
  color: #fff;
  font-size: 55%;
  height: 100%;
}
body {
  height: 100%;
}
html,
body {
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
}
.grow {
  flex-grow: 1;
}
@media screen and (max-width: 1500px) {
  html {
    font-size: 45%;
  }
}
body,
input,
input:-webkit-autofill::first-line,
input:-webkit-autofill,
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea,
a {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.8rem;
  letter-spacing: 0.03em;
}
a {
  color: #DAD2D6;
  font-weight: 300;
}
a:hover {
  font-weight: 400;
}
a:active {
  color: #FFAE00;
  font-weight: 400;
}
h1 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 6.6rem;
  line-height: 110%;
  letter-spacing: 0.01em;
  margin: 3.2rem;
}
h2 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 5rem;
  line-height: 120%;
  letter-spacing: 0.01em;
  margin: 3.2rem;
}
h3 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 3.8rem;
  line-height: 120%;
  letter-spacing: 0.01em;
}
h4 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.4rem;
  line-height: 120%;
  margin: 0;
}
h5 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.1rem;
  line-height: 120%;
  margin: 0.2rem;
  word-wrap: break-word;
}
h6 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 1.6rem;
  line-height: 120%;
  margin: 0;
}
.link {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 1.4rem;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.link:hover {
  font-weight: 400;
}
.button-text {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.1rem;
  line-height: 120%;
  letter-spacing: 0.01em;
}
.table-text {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 1.2rem;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.go2sim-red-text {
  color: #E84230;
}
.grow {
  flex-grow: 1;
  flex-basis: 50%;
}
.nowrap {
  white-space: nowrap;
}
input {
  background-color: #ffffff;
  outline: none;
  border-radius: 12.8rem;
  border: none;
  padding: 0.8rem 3.2rem;
  color: #171516;
  box-sizing: border-box;
}
.button {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.1rem;
  line-height: 120%;
  letter-spacing: 0.01em;
  border-radius: 3rem;
  color: white;
  padding: 1.2rem 3.2rem;
  transition-duration: 0.2s;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  position: relative;
}
.button.gradient {
  background: linear-gradient(90deg, #b2005d 0%, #d50d43 11.46%, #f62925 50.52%, #ffae00 90.63%);
  box-shadow: 6px 4px 1rem 4px inset #ffffff17, inset -2px -6px 1rem 0rem #0000003b, -3px -3px 3px #ffffff1f, 3px 3px 3px 0px #00000029 !important;
  margin: 0.5rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
.button:hover {
  box-shadow: 0 0.4rem 3rem rgba(23, 1, 22, 0.8);
  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);
}
.button.outline {
  background: transparent;
  box-shadow: 0 0 0 0.2rem white inset;
}
.button.outline:hover {
  background: linear-gradient(90deg, #B2005D 0%, #D50D43 11.46%, #F62925 50.52%, #FFAE00 90.63%);
  color: white;
  font-weight: 800;
  box-shadow: 0 0 0 0 white inset;
}
.button.solid {
  background: white;
  color: #171516;
}
.button.solid:hover {
  background: #171516;
  color: white;
}
.button.red {
  background: #E84230;
  color: white;
}
.button.red:hover {
  background: #E84230;
  color: #171516;
  font-weight: 800;
}
.button.inline {
  display: inline-flex;
}
.button.autosize {
  width: fit-content;
}
.button.stretch {
  width: 100%;
}
.button.vspaced {
  margin: 1.6rem 0 !important;
}
.button.disabled {
  opacity: 0.5;
  color: #000;
  cursor: default;
}
.button.small {
  font-size: inherit;
  padding: 0.6rem 1.3rem;
}
.button.grow {
  flex-grow: 1;
}
.button.noshadow {
  box-shadow: none !important;
}
.gradient-title {
  background: linear-gradient(360deg, #B2005D -14.55%, #D50D43 10.45%, #F62925 45.01%, #FFAE00 109.71%);
  text-align: center;
  border-top-left-radius: 3.2rem;
  border-top-right-radius: 3.2rem;
  padding: 1.6rem;
}
.gradient-card {
  background: linear-gradient(360deg, #B2005D -14.55%, #D50D43 10.45%, #F62925 45.01%, #FFAE00 109.71%);
  border-radius: 3.2rem;
  padding: 1.6rem;
}
.hover-icon {
  position: relative;
  height: 1.4rem;
}
.hover-icon img {
  position: absolute;
  height: 100%;
  transition-duration: 0.25s;
}
.hover-icon .normal {
  opacity: 1;
}
.hover-icon .hover {
  opacity: 0;
}
.hover-icon:hover .normal {
  opacity: 0;
}
.hover-icon:hover .hover {
  opacity: 1;
}
.white-glass {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 2.5rem;
  box-shadow: 0 0 0.2rem rgba(255, 255, 255, 0.1), inset 0.1rem 0 0 rgba(255, 255, 255, 0.05), inset -0.1rem 0 0 rgba(255, 255, 255, 0.05), inset 0 -0.1rem 0 rgba(255, 255, 255, 0.05), inset 0 0.1rem 0 rgba(255, 255, 255, 0.05), inset 0 0 0.1rem rgba(255, 255, 255, 0.1);
  margin: 4.8rem;
  margin-bottom: 0;
  padding: 3.2rem 6.4rem;
  display: flex;
  gap: 10%;
}
.white-glass .wrapper {
  max-width: 50%;
}
.white-glass h2 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.card {
  box-shadow: 0.2rem 0.2rem 0.8rem rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  color: #171516;
  border-radius: 1rem;
  border: 0.1rem solid #b1b1b1;
  padding: 1.2rem;
}
.options {
  box-shadow: 0.2rem 0.2rem 0.8rem rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  color: #171516;
  border-radius: 1rem;
  border: 0.1rem solid #b1b1b1;
  padding: 1.2rem;
}
.options .option {
  padding: 0.8rem 1.6rem;
  cursor: pointer;
  transition-duration: 0.25s;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.options .option img {
  height: 1rem !important;
  padding-left: 1rem;
}
.options .option:hover {
  background-color: #e8423038;
  border-radius: 0.6rem;
}
.section-head h4,
.section-head h5 {
  white-space: nowrap;
}
.section-head .icons {
  flex-grow: 1;
  flex-basis: 50%;
  display: flex;
  justify-content: right;
  align-items: center;
}
.section-head .icons .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  margin: 0 0.8rem;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
}
.section-head .icons .icon img {
  width: 2.4rem;
  height: 2.4rem;
}
.section-head {
  background-color: #0D0C0C;
  border-top-left-radius: 3.2rem;
  border-top-right-radius: 3.2rem;
  padding: 1.6rem 3.2rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.section-foot {
  background-color: #0D0C0C;
  border-bottom-left-radius: 3.2rem;
  border-bottom-right-radius: 3.2rem;
  padding: 1.6rem 3.2rem;
  min-height: 3rem;
  text-align: center;
}
.section-body {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  background: #171516;
  padding: 5rem 3.2rem;
}
.vertical-form {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
}
.form-row {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: right;
  align-items: center;
}
.form-row label {
  flex-basis: 25%;
  flex-grow: 1;
}
.form-row input {
  flex-basis: 75%;
  flex-grow: 1;
}
.horizontal-rule {
  width: auto;
  border-bottom: 1px solid #323232;
  margin: 2.4rem 0rem;
  box-sizing: border-box;
}
.wrapper.right {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
}
.wrapper.right img {
  width: 7rem;
}
.wrapper.right p {
  text-align: left;
  line-height: 2.2rem;
}
`, "",{"version":3,"sources":["webpack://./styles/layout.less","webpack://./styles/controls.less","webpack://./styles/typography.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;ACCF;ADEA;EACE,YAAA;ACAF;ADGA;;EACE,SAAA;EAAU,UAAA;ACCZ;ADEA;EACE,YAAA;ACAF;ADGA;EACE,YAAA;ACDF;ADIA;EACE;IACE,cAAA;ECFF;AACF;ACrBA;;;;;;;;;EASE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;ADuBF;ACpBA;EACE,cAAA;EACA,gBAAA;ADsBF;ACnBA;EACE,gBAAA;ADqBF;AClBA;EACE,cAAA;EACA,gBAAA;ADoBF;ACjBA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ADmBF;AChBA;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;ADkBF;ACfA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;ADiBF;ACdA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;ADgBF;ACbA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;ADeF;ACZA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;ADcF;ACXA;EACE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;ADaF;ACVA;EACE,gBAAA;ADYF;ACTA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;ADWF;ACRA;EACE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;ADUF;ACPA;EACE,cAAA;ADSF;AAvHA;EACE,YAAA;EACA,eAAA;AAyHF;AAtHA;EACE,mBAAA;AAwHF;AArHA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;AAuHF;AApHA;EC2EE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;ED7EA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;AA0HF;AAvHA;EACE,8FAAA;EAOA,gJAAA;EAKA,cAAA;EACA,2CAAA;AA+GF;AA5GA;EACE,8CAAA;EACA,6CAAA;AA8GF;AA3GA;EACE,uBAAA;EACA,oCAAA;AA6GF;AA1GA;EACE,8FAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;AA4GF;AAzGA;EACE,iBAAA;EACA,cAAA;AA2GF;AAxGA;EACE,mBAAA;EACA,YAAA;AA0GF;AAvGA;EACE,mBAAA;EACA,YAAA;AAyGF;AAtGA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAwGF;AArGA;EACE,oBAAA;AAuGF;AApGA;EACE,kBAAA;AAsGF;AAnGA;EACE,WAAA;AAqGF;AAlGA;EACE,2BAAA;AAoGF;AAjGA;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAmGF;AAhGA;EACE,kBAAA;EACA,sBAAA;AAkGF;AA/FA;EACE,YAAA;AAiGF;AA9FA;EACE,2BAAA;AAgGF;AA7FA;EACE,qGAAA;EACA,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AA+FF;AA5FA;EACE,qGAAA;EACA,qBAAA;EACA,eAAA;AA8FF;AA3FA;EACE,kBAAA;EACA,cAAA;AA6FF;AA1FA;EACE,kBAAA;EACA,YAAA;EACA,0BAAA;AA4FF;AAzFA;EACE,UAAA;AA2FF;AAxFA;EACE,UAAA;AA0FF;AAvFA;EACE,UAAA;AAyFF;AAtFA;EACE,UAAA;AAwFF;AArFA;EACE,qCAAA;EACA,qBAAA;EACA,4QAAA;EAOA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,QAAA;AAiFF;AA9EA;EACE,cAAA;AAgFF;AA7EA;EACE,yBAAA;EACA,0BAAA;AA+EF;AA5EA;EACE,mDAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;AA8EF;AA3EA;EACE,mDAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;AA6EF;AA1EA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA4EF;AAzEA;EACE,uBAAA;EACA,kBAAA;AA2EF;AAxEA;EACE,2BAAA;EACA,qBAAA;AA0EF;AAvEA;;EAEE,mBAAA;AAyEF;AAtEA;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAwEF;AArEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAuEF;AApEA;EACE,aAAA;EACA,cAAA;AAsEF;AAnEA;EACE,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAqEF;AAlEA;EACE,yBAAA;EACA,iCAAA;EACA,kCAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAoEF;AAjEA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAmEF;AA9DA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAgEF;AA7DA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;AA+DF;AA5DA;EACE,eAAA;EACA,YAAA;AA8DF;AA3DA;EACE,eAAA;EACA,YAAA;AA6DF;AA1DA;EACE,WAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;AA4DF;AAzDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AA2DF;AAxDA;EACE,WAAA;AA0DF;AAvDA;EACE,gBAAA;EACA,mBAAA;AAyDF","sourcesContent":["html {\n  background: #241f1c;\n  color: #fff;\n  font-size: 55%;\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n}\n\nhtml, body {\n  margin:0; padding:0;\n}\n\n#app {\n  height: 100%;\n}\n\n.grow {\n  flex-grow: 1;\n}\n\n@media screen and (max-width: 1500px) {\n  html {\n    font-size: 45%;\n  }\n}","@import 'colours.less';\n@import 'typography.less';\n\n.grow {\n  flex-grow: 1;\n  flex-basis: 50%;\n}\n\n.nowrap {\n  white-space: nowrap;\n}\n\ninput {\n  background-color: #ffffff;\n  outline: none;\n  border-radius: 12.8rem;\n  border: none;\n  padding: 0.8rem 3.2rem;\n  color: @go2sim-black;\n  box-sizing: border-box;\n}\n\n.button {\n  .button-text();\n  border-radius: 3rem;\n  color: white;\n  padding: 1.2rem 3.2rem;\n  transition-duration: 0.2s;\n  text-align: center;\n  cursor: pointer;\n  text-decoration: none;\n  position: relative;\n}\n\n.button.gradient {\n  background: linear-gradient(\n    90deg,\n    #b2005d 0%,\n    #d50d43 11.46%,\n    #f62925 50.52%,\n    #ffae00 90.63%\n  );\n  box-shadow:\n    6px 4px 1rem 4px inset #ffffff17,\n    inset -2px -6px 1rem 0rem #0000003b,\n    -3px -3px 3px #ffffff1f,\n    3px 3px 3px 0px #00000029 !important;\n  margin: 0.5rem;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.button:hover {\n  box-shadow: 0 0.4rem 3rem rgba(23, 1, 22, 0.8);\n  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.button.outline {\n  background: transparent;\n  box-shadow: 0 0 0 0.2rem white inset;\n}\n\n.button.outline:hover {\n  background: @horizontal-gradient;\n  color: white;\n  font-weight: 800;\n  box-shadow: 0 0 0 0 white inset;\n}\n\n.button.solid {\n  background: white;\n  color: @go2sim-black;\n}\n\n.button.solid:hover {\n  background: @go2sim-black;\n  color: white;\n}\n\n.button.red {\n  background: @go2sim-red;\n  color: white;\n}\n\n.button.red:hover {\n  background: @go2sim-red;\n  color: @go2sim-black;\n  font-weight: 800;\n}\n\n.button.inline {\n  display: inline-flex;\n}\n\n.button.autosize {\n  width: fit-content;\n}\n\n.button.stretch {\n  width: 100%;\n}\n\n.button.vspaced {\n  margin: 1.6rem 0 !important;\n}\n\n.button.disabled {\n  opacity: 0.5;\n  color: #000;\n  cursor: default;\n}\n\n.button.small {\n  font-size: inherit;\n  padding: 0.6rem 1.3rem;\n}\n\n.button.grow {\n  flex-grow: 1;\n}\n\n.button.noshadow {\n  box-shadow: none !important;\n}\n\n.gradient-title {\n  background: @vertical-gradient;\n  text-align: center;\n  border-top-left-radius: 3.2rem;\n  border-top-right-radius: 3.2rem;\n  padding: 1.6rem;\n}\n\n.gradient-card {\n  background: @vertical-gradient;\n  border-radius: 3.2rem;\n  padding: 1.6rem;\n}\n\n.hover-icon {\n  position: relative;\n  height: 1.4rem;\n}\n\n.hover-icon img {\n  position: absolute;\n  height: 100%;\n  transition-duration: 0.25s;\n}\n\n.hover-icon .normal {\n  opacity: 1;\n}\n\n.hover-icon .hover {\n  opacity: 0;\n}\n\n.hover-icon:hover .normal {\n  opacity: 0;\n}\n\n.hover-icon:hover .hover {\n  opacity: 1;\n}\n\n.white-glass {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 2.5rem;\n  box-shadow:\n    0 0 0.2rem rgba(255, 255, 255, 0.1),\n    inset 0.1rem 0 0 rgba(255, 255, 255, 0.05),\n    inset -0.1rem 0 0 rgba(255, 255, 255, 0.05),\n    inset 0 -0.1rem 0 rgba(255, 255, 255, 0.05),\n    inset 0 0.1rem 0 rgba(255, 255, 255, 0.05),\n    inset 0 0 0.1rem rgba(255, 255, 255, 0.1);\n  margin: 4.8rem;\n  margin-bottom: 0;\n  padding: 3.2rem 6.4rem;\n  display: flex;\n  gap: 10%;\n}\n\n.white-glass .wrapper {\n  max-width: 50%;\n}\n\n.white-glass h2 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.card {\n  box-shadow: 0.2rem 0.2rem 0.8rem rgb(0 0 0 / 20%);\n  background-color: #ffffff;\n  color: #171516;\n  border-radius: 1rem;\n  border: 0.1rem solid #b1b1b1;\n  padding: 1.2rem;\n}\n\n.options {\n  box-shadow: 0.2rem 0.2rem 0.8rem rgb(0 0 0 / 20%);\n  background-color: #ffffff;\n  color: #171516;\n  border-radius: 1rem;\n  border: 0.1rem solid #b1b1b1;\n  padding: 1.2rem;\n}\n\n.options .option {\n  padding: 0.8rem 1.6rem;\n  cursor: pointer;\n  transition-duration: 0.25s;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.options .option img {\n  height: 1rem !important;\n  padding-left: 1rem;\n}\n\n.options .option:hover {\n  background-color: #e8423038;\n  border-radius: 0.6rem;\n}\n\n.section-head h4,\n.section-head h5 {\n  white-space: nowrap;\n}\n\n.section-head .icons {\n  flex-grow: 1;\n  flex-basis: 50%;\n  display: flex;\n  justify-content: right;\n  align-items: center;\n}\n\n.section-head .icons .icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.8rem;\n  margin: 0 0.8rem;\n  cursor: pointer;\n  position: relative;\n  white-space: nowrap;\n}\n\n.section-head .icons .icon img {\n  width: 2.4rem;\n  height: 2.4rem;\n}\n\n.section-head {\n  background-color: @darker-black;\n  border-top-left-radius: 3.2rem;\n  border-top-right-radius: 3.2rem;\n  padding: 1.6rem 3.2rem;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.section-foot {\n  background-color: @darker-black;\n  border-bottom-left-radius: 3.2rem;\n  border-bottom-right-radius: 3.2rem;\n  padding: 1.6rem 3.2rem;\n  min-height: 3rem;\n  text-align: center;\n}\n\n.section-body {\n  display: flex;\n  width: 100%;\n  box-sizing: border-box;\n  background: @go2sim-black;\n  padding: 5rem 3.2rem;\n  // border-bottom-left-radius: 3.2rem;\n  // border-bottom-right-radius: 3.2rem;\n}\n\n.vertical-form {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  width: 100%;\n}\n\n.form-row {\n  display: flex;\n  flex-direction: row;\n  gap: 2rem;\n  justify-content: right;\n  align-items: center;\n}\n\n.form-row label {\n  flex-basis: 25%;\n  flex-grow: 1;\n}\n\n.form-row input {\n  flex-basis: 75%;\n  flex-grow: 1;\n}\n\n.horizontal-rule {\n  width: auto;\n  border-bottom: 1px solid #323232;\n  margin: 2.4rem 0rem;\n  box-sizing: border-box;\n}\n\n.wrapper.right {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 2rem;\n}\n\n.wrapper.right img {\n  width: 7rem;\n}\n\n.wrapper.right p {\n  text-align: left;\n  line-height: 2.2rem;\n}","@import 'layout.less';\n@import 'colours.less';\n\nbody,\ninput,\ninput:-webkit-autofill::first-line,\ninput:-webkit-autofill,\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea,\na {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 300;\n  font-size: 1.6rem;\n  line-height: 2.8rem;\n  letter-spacing: 0.03em;\n}\n\na {\n  color: @text-grey;\n  font-weight: 300;\n}\n\na:hover {\n  font-weight: 400;\n}\n\na:active {\n  color: @honey-yellow;\n  font-weight: 400;\n}\n\nh1 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 6.6rem;\n  line-height: 110%;\n  letter-spacing: 0.01em;\n  margin: 3.2rem;\n}\n\nh2 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 5rem;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n  margin: 3.2rem;\n}\n\nh3 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 3.8rem;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n}\n\nh4 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 2.4rem;\n  line-height: 120%;\n  margin: 0;\n}\n\nh5 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 2.1rem;\n  line-height: 120%;\n  margin: 0.2rem;\n  word-wrap: break-word;\n}\n\nh6 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 1.6rem;\n  line-height: 120%;\n  margin: 0;\n}\n\n.link {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 300;\n  font-size: 1.4rem;\n  line-height: 120%;\n  letter-spacing: 0.03em;\n}\n\n.link:hover {\n  font-weight: 400;\n}\n\n.button-text {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 2.1rem;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n}\n\n.table-text {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 300;\n  font-size: 1.2rem;\n  line-height: 120%;\n  letter-spacing: 0.03em;\n}\n\n.go2sim-red-text {\n  color: @go2sim-red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
